module.exports = __webpack_public_path__ + "img/mail.f2169ff1.svg";